// ~~ Generated. This file cannot be edited directly. Please look at libs/nx-tooling/src/generators/backoffice-project/generator.ts

import {
  LegalDocumentManagementAreaId,
  LegalDocumentManagementAreaRoutes,
} from '@backoffice-frontend/common'
import { SuspenseLoadingWrapper } from '@backoffice-frontend/patterns'
import { BoumRight } from '@moia-dev/moia-token-claims'
import { lazy } from 'react'

import {
  LegalDocumentManagementAreaNavigation,
  LegalDocumentManagementAreaNavigationIcon,
} from './LegalDocumentManagementAreaNavigation'

const LazyLegalDocumentManagementComponent = lazy(
  () => import('./LegalDocumentManagementArea'),
)

const LegalDocumentManagementComponent = () => (
  <SuspenseLoadingWrapper>
    <LazyLegalDocumentManagementComponent />
  </SuspenseLoadingWrapper>
)

export const LegalDocumentManagementArea = {
  id: LegalDocumentManagementAreaId,
  requiredRight: BoumRight.BACKOFFICE_LEGAL_DOCUMENT_R,
  Icon: LegalDocumentManagementAreaNavigationIcon,
  NavigationComponent: LegalDocumentManagementAreaNavigation,
  route: {
    path: LegalDocumentManagementAreaRoutes.route,
    component: LegalDocumentManagementComponent,
  },
}
